export default "__VITE_ASSET__CgT1JTQz__"